import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Paper, styled } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


class NIvelEducativo extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            nivel: {
                grado: '',
            },
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnviar = this.manejarEnviar.bind(this);
    }

    async componentDidMount(){
        //Consulto si ya tiene ingresado algo
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, sessionStorage.nombreFuncionario]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_nivelEducativo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        if(res[0]){
            this.setState(state => {
                const funcionarioActualizado = state.nivel;
                funcionarioActualizado['grado'] = res[1];
                return{
                    nivel: funcionarioActualizado,
                };
            })
        }
    }

    render(){

        return (
            <>
                <h3>Nivel Educativo</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
                <Container>
                    <Box sx={{ flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={3.5}>
                            </Grid>
                            <Grid item xs={5}>
                                <Item>¿Cuál es el máximo nivel educativo que ha aprobado?</Item>
                            </Grid>
                            <Grid item xs={3.5}>
                            </Grid>
                            <Grid item xs={4.5}>
                            </Grid>
                            <Grid item xs={3}>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="grado" value={this.state.nivel.grado} onChange={this.manejarCambiosDatos}>
                                    <option value={''}></option>
                                    <option value={1} style={{textAlign: 'center'}}>Primaria</option>
                                    <option value={2} style={{textAlign: 'center'}}>Secundaria</option>
                                    <option value={3} style={{textAlign: 'center'}}>Terciario no universitario</option>
                                    <option value={4} style={{textAlign: 'center'}}>Grado universitario</option>
                                    <option value={5} style={{textAlign: 'center'}}>Maestría universitaria</option>
                                    <option value={6} style={{textAlign: 'center'}}>Posgrado universitario</option>
                                    <option value={7} style={{textAlign: 'center'}}>Doctorado</option>
                                    <option value={8} style={{textAlign: 'center'}}>Ninguno</option>
                                </select>
                            </Grid>
                        </Grid>
                    </Box>
                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'1rem'}} type='button' onClick={this.manejarEnviar}>Confirmar</button>
                </Container>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.nivel;
            funcionarioActualizado[clave] = valor;
            return{
                nivel: funcionarioActualizado,
            };
        })
    }

    async manejarEnviar(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, sessionStorage.nombreFuncionario, this.state.nivel]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/guardar_nivelEducativo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        this.setState({
            errores: res[0],
            loading: false,
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Nivel ingresado correctamente',
            })
        }
    }
}

export default NIvelEducativo